module.exports = __webpack_public_path__ + "static/media/purple.1fb9337a.svg";